import breakpoints from './breakpoints';
import fontFamily from './fonts';
import colors from './colors';
import colorsUI from './colorsUI';
import fontUnits from './fontSize';
import spacerUnits from './spacer';
import radius from './borderRadius';
import inputHeight from './forms';

const theme = {
  breakpoints,
  fontFamily,
  ...colors,
  ...colorsUI,
  ...fontUnits,
  ...spacerUnits,
  radius,
  inputHeight
};

export default theme;



// WEBPACK FOOTER //
// ./src/global/theme.js